import * as React from 'react';
import * as PropTypes from 'prop-types';

import * as styles from './SelectionModeButton.module.scss';

/**
 * @param {Object} props
 * @param {{{ default: string; selection: string }}} props.content
 * @param {() => void} props.onClick
 * @param {boolean} props.isInSelectionMode
 */
export const SelectionModeButton = ({
  content,
  onClick,
  isInSelectionMode,
}) => {
  const qaSelector = isInSelectionMode
    ? 'gdpr-banner-accept-selected-button'
    : 'gdpr-banner-configuration-button';

  return (
    <span
      tabIndex={0}
      onClick={onClick}
      role="button"
      className={styles.selectionModeButton}
      data-qa-selector={qaSelector}
    >
      {isInSelectionMode ? content.selection : content.default}
    </span>
  );
};

SelectionModeButton.propTypes = {
  content: PropTypes.shape({
    default: PropTypes.string.isRequired,
    selection: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  isInSelectionMode: PropTypes.bool.isRequired,
};
